export enum TimePeriod {
    PAST,
    PRESENT,
    FUTURE
}
